
    import { defineComponent, getCurrentInstance, nextTick, onMounted, ref } from 'vue'
    import { isValidPhone } from '@/helpers/validators/phoneValidator'
    import { useProject } from '@/hooks/useProject'
    import api from '@root/src/api/api'

    function formatPhone(value: string): string {
        let digits = String(value || '').replace(/\D/g, '')
        if (!digits) return ''
        if (digits.startsWith('8')) digits = `7${digits.slice(1)}`
        if (!digits.startsWith('7')) digits = `7${digits}`
        digits = digits.slice(0, 11)
        const local = digits.slice(1)
        let out = '+7'
        if (local.length) out += ` (${local.slice(0, 3)}`
        if (local.length >= 3) out += ')'
        if (local.length > 3) out += ` ${local.slice(3, 6)}`
        if (local.length > 6) out += `-${local.slice(6, 8)}`
        if (local.length > 8) out += `-${local.slice(8, 10)}`
        return out
    }

    export default defineComponent({
        setup() {
            const { project } = useProject()
            const loading = ref(false)
            const isEditing = ref(false)
            const showError = ref(false)
            const root = getCurrentInstance().proxy
            const phoneInput = ref<HTMLInputElement | null>(null)
            const notificationPhone = ref<string>('')
            const notificationPhoneOld = ref<string>('')

            const onInput = (event: Event) => {
                const target = event.target as HTMLInputElement
                notificationPhone.value = formatPhone(target.value)
                showError.value = false
            }

            const startEditing = async () => {
                isEditing.value = true
                showError.value = false
                await nextTick()
                const input = phoneInput.value
                if (!input) return
                input.focus()
                const length = input.value.length
                input.setSelectionRange(length, length)
            }

            const cancelEditing = () => {
                notificationPhone.value = notificationPhoneOld.value
                showError.value = false
                isEditing.value = false
            }

            const submitNotificationPhone = async () => {
                if (!isValidPhone(notificationPhone.value)) {
                    showError.value = true
                    return
                }
                if (notificationPhone.value === notificationPhoneOld.value) {
                    isEditing.value = false
                    return
                }
                loading.value = true
                const { error } = await api.marketplace.saveNotificationPhone({
                    projectId: project.value.id,
                    phone: notificationPhone.value,
                })
                await fetchPhone()
                if (!error) {
                    root.$store.dispatch('callNotify', 'Номер успешно сохранен!')
                    isEditing.value = false
                    showError.value = false
                }
                loading.value = false
            }

            const fetchPhone = async () => {
                const { data, error } = await api.marketplace.getNotificationPhone(project.value.id)
                if (error) {
                    root.$store.dispatch('callNotify', 'Произошла ошибка при загрузке текущего тарифа')
                    return
                }
                if (!error && data?.phone) {
                    const formatted = formatPhone(data.phone)
                    notificationPhone.value = formatted
                    notificationPhoneOld.value = formatted
                }
            }

            const onKeydown = (event: KeyboardEvent) => {
                if (event.key === 'Enter' && isEditing.value) {
                    event.preventDefault()
                    submitNotificationPhone()
                }
                if (event.key === 'Escape' && isEditing.value) {
                    event.preventDefault()
                    cancelEditing()
                }
            }

            onMounted(async () => {
                await fetchPhone()
            })

            return {
                notificationPhone,
                submitNotificationPhone,
                loading,
                isEditing,
                showError,
                startEditing,
                cancelEditing,
                onInput,
                onKeydown,
                phoneInput,
            }
        },
    })
